export default __webpack_public_path__ + "static/media/audit.4ec43297.png";